export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8206.51b0f335.jpg";